var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.21484 25C7.21484 27.4623 7.69983 29.9005 8.6421 32.1753C9.58438 34.4502 10.9655 36.5172 12.7066 38.2582C14.4477 39.9993 16.5147 41.3805 18.7895 42.3227C21.0644 43.265 23.5026 43.75 25.9648 43.75C28.4271 43.75 30.8653 43.265 33.1402 42.3227C35.415 41.3805 37.482 39.9993 39.2231 38.2582C40.9642 36.5172 42.3453 34.4502 43.2876 32.1753C44.2299 29.9005 44.7148 27.4623 44.7148 25C44.7148 20.0272 42.7394 15.2581 39.2231 11.7417C35.7068 8.22544 30.9377 6.25 25.9648 6.25C20.992 6.25 16.2229 8.22544 12.7066 11.7417C9.19028 15.2581 7.21484 20.0272 7.21484 25Z",
    stroke: "#111827",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9648 14.5833V24.9999L32.2148 31.2499",
    stroke: "#2C2C2C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.964844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery02);
export default __webpack_public_path__ + "static/media/delivery-02.848f683885e5d4b69af306242a5fcc5e.svg";
export { ForwardRef as ReactComponent };